import React from 'react';

interface PendingDotsProps {
  label?: string;
}

/**
 * Three dots strobing left to right — the shared "waiting on the server" indicator, used
 * both inline in the encounter dialog and in the blocking loading overlay.
 */
export const PendingDots: React.FC<PendingDotsProps> = ({label = 'Waiting for response'}) => (
  <div className="pending-dots" aria-label={label}>
    <span/>
    <span/>
    <span/>
  </div>
);
